import React from "react";
import { Menu } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import { version } from "../../../package.json";
import styles from "./styles.module.scss";
import messages from "./messages";

const ApexFooter = () => (
  <Menu className={styles.appFooter}>
    <Menu.Item position="left">
      <FormattedMessage {...messages.copyright} />
    </Menu.Item>
    <Menu.Item position="right">ver {version}</Menu.Item>
  </Menu>
);

export default ApexFooter;
